<template>
    <div class="markbox" @click.prevent="cancel">
        <div class="short_play" @click.stop="handleClick"></div>
    </div>
</template>

<script>

export default {
    data() {
        return {}
    },
    created() {},
    computed: {
    },
    methods: {
        cancel() {
            window.sessionStorage.setItem('showShortPlayDialog', 'false');
            this.$emit('showShortPlayDialog', false);
        },
        handleClick() {
            this.cancel();
            window.open('https://mp.weixin.qq.com/s/ploZ3YHchMeMUTm7Ef-d2g', '_blank');
        }
    }
}
</script>

<style scoped lang="scss">
* {
  padding: 0;
  margin: 0;
  font-style: normal;
}

.markbox {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2002;
    display: flex;
    align-items: center;
    justify-content: center;
}

.markbox .short_play {
    width: 500px;
    height: 500px;
    background: url('images/20250916-shortplay.png') no-repeat;
    background-size: cover;
}

</style>